<ng-template
  *ngIf="mobileService.getIsMobile()"
  [ngTemplateOutlet]="mobile"
></ng-template>

<ng-template #mobile>
  <header>
    <div>
      <img
        (click)="container.goBackFunction()"
        src="/assets/icons/arrow_back.svg"
      />
    </div>
    <div>
      <h3 class="title">{{ container.getTitle() }}</h3>
    </div>
    <div>
      <img
        (click)="openDrawer()"
        src="/assets/icons/menu.svg"
      />
    </div>
  </header>
  <div class="spacer"></div>
  <main>
    <router-outlet></router-outlet>
  </main>
  <!-- <footer></footer> -->
  <app-drawer
    [open]="drawerOpen"
    (onClose)="closeDrawer()"
  ></app-drawer>
</ng-template>
